<!-- 查询车辆信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
          requestBody: {
            "bills": [
              {
                "parkCode": "123123",
                "billCode": "123123",
                "billType": 1
              }
            ],
          },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordList": [
                      {
                        "bills": [
                          {
                            "parkCode": "123123",
                            "billCode": "123123",
                            "billType": 1
                          }
                        ],
                      },
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,获取用户可开发票订单",
                t_url: this.commonUrls.test+"getInvoiceRecord",
                p_url: this.commonUrls.prod+"getInvoiceRecord",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'bills', info2: '是', info3: 'JSONArray', info4: '账单列表' },
                        ]
                },{
                  titleName: "bills 账单列表",
                  tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                  td: [
                    { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                    { info1: 'billCode', info2: '是', info3: 'String', info4: '账单号' },
                    { info1: 'billType', info2: '是', info3: 'Integer', info4: '业务类型：0:停车缴费,1:月票,2:电子优惠券,3:月票管理费' },
                  ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'recordList', info2: '是', info3: 'JSONArray', info4: '账单信息列表' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'bills', info2: '是', info3: 'JSONArray', info4: '账单列表' },
                    ]
                },
                  {
                    titleName: "bills 账单列表",
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'parkCode', info2: '是', info3: 'String', info4: '车场编码' },
                      { info1: 'billCode', info2: '是', info3: 'String', info4: '账单号' },
                      { info1: 'billType', info2: '是', info3: 'Integer', info4: '业务类型：0:停车缴费,1:月票,2:电子优惠券,3:月票管理费' },
                    ]
                  }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getInvoiceRecord.vue